var __jsx = React.createElement;
import React, { useState } from "react";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import { get } from "lodash";
import classNames from "classnames";
import { truncateMiddle } from "../../utils";
import Modal from "../common/Modal";
import { faCircleCheck, faArrowUpRightFromSquare } from "@fortawesome/pro-regular-svg-icons";
import AwesomeIcon from "../AwesomeIcon";
import { t } from "i18next";
var MinimizeIcon = function MinimizeIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill-gray-800 dark:fill-[#D9DBDD]",
    fillRule: "evenodd",
    d: "M21.619 2.381a.875.875 0 0 0-1.238 0L9.735 13.027l.145-3.854a.875.875 0 1 0-1.749-.066l-.228 6.082a.875.875 0 0 0 .907.907l6.081-.228a.875.875 0 0 0-.065-1.749l-3.852.145L21.619 3.619a.875.875 0 0 0 0-1.238Zm-7.156.28a.875.875 0 0 1 0 1.75H5.545a2.304 2.304 0 0 0-2.303 2.303v11.985a2.304 2.304 0 0 0 2.303 2.304H17.53a2.304 2.304 0 0 0 2.304-2.304V9.258a.875.875 0 1 1 1.75 0v9.44a4.054 4.054 0 0 1-4.054 4.055H5.545a4.054 4.054 0 0 1-4.053-4.054V6.714A4.054 4.054 0 0 1 5.545 2.66h8.918Z",
    clipRule: "evenodd"
  }));
};
var UploadProgressModal = function UploadProgressModal(props) {
  var selectedFiles = props.selectedFiles,
    totalFilesCount = props.totalFilesCount,
    uploadSuccessCount = props.uploadSuccessCount;
  var files = Object.values(selectedFiles);
  var _useState = useState(true),
    isMinimized = _useState[0],
    toggleMinimize = _useState[1];
  var _useState2 = useState(false),
    isHovering = _useState2[0],
    toggleHovering = _useState2[1];
  var onHoverOverTable = function onHoverOverTable(hovering) {
    toggleHovering(hovering);
  };
  var getFileStatus = function getFileStatus(fileObj) {
    var uploadComplete = get(fileObj, ["uploadComplete"], false);
    // const uploadProgress = get(fileObj, ['uploadProgress'], 0)

    if (!isMinimized && !isHovering && uploadComplete) {
      var _document$getElementB;
      var fileName = get(fileObj, ["fileName"], "");
      // eslint-disable-next-line no-unused-expressions
      (_document$getElementB = document.getElementById(fileName)) === null || _document$getElementB === void 0 || _document$getElementB.scrollIntoView();
    }
    if (uploadComplete) {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex items-center justify-start"
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faCircleCheck,
        className: "text-green-600 w-6"
      }), /*#__PURE__*/React.createElement("div", {
        className: "is-size-7 is-italic pl-2 italic"
      }, t("import_successful")));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "italic"
    }, t("in_progress"), "...");
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ParentComponent, {
    toggleMinimize: toggleMinimize,
    isMinimized: isMinimized
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-6 py-3 my-3 h-60 overflow-y-auto scrollbar-light dark:scrollbar"
  }, /*#__PURE__*/React.createElement("table", {
    className: "min-w-full text-left rounded p-4",
    onFocus: function onFocus() {
      return onHoverOverTable(true);
    },
    onMouseEnter: function onMouseEnter() {
      return onHoverOverTable(true);
    },
    onBlur: function onBlur() {
      return onHoverOverTable(false);
    },
    onMouseLeave: function onMouseLeave() {
      return onHoverOverTable(false);
    }
  }, /*#__PURE__*/React.createElement("tbody", {
    className: "text-black dark:text-white"
  }, files.map(function (fileObj) {
    var fileName = get(fileObj, ["fileName"], "");
    var patientName = get(fileObj, ["metaData", "PatientName"], "-");
    var SOPInstanceUID = get(fileObj, ["metaData", "SOPInstanceUID"], "-");
    var uploadComplete = get(fileObj, ["uploadComplete"], false);
    return /*#__PURE__*/React.createElement("tr", {
      key: fileName,
      id: fileName,
      className: classNames("leading-8", {
        "opacity-50": !uploadComplete
      })
    }, /*#__PURE__*/React.createElement("td", {
      className: "w-1/4",
      title: SOPInstanceUID
    }, truncateMiddle(SOPInstanceUID, 20)), /*#__PURE__*/React.createElement("td", {
      className: "w-1/4"
    }, truncateMiddle(patientName, 20)), /*#__PURE__*/React.createElement("td", {
      className: "w-1/4"
    }, getFileStatus(fileObj)));
  }))))), isMinimized && /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    onClick: function onClick() {
      trackEvent(MIXPANEL_EVENTS.DICOM_UPLOAD_PROGRESS_RESTORED);
      toggleMinimize(false);
    },
    className: "absolute bottom-2 left-2 flex items-center justify-between w-80 bg-gray-500 text-black dark:text-white p-3 pl-4 rounded-md cursor-pointer z-50"
  }, /*#__PURE__*/React.createElement("div", null, t("import_progress"), "... ", uploadSuccessCount, " of ", totalFilesCount), /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faArrowUpRightFromSquare,
    className: "w-6"
  })));
};
export default UploadProgressModal;
var ParentComponent = function ParentComponent(_ref) {
  var children = _ref.children,
    toggleMinimize = _ref.toggleMinimize,
    isMinimized = _ref.isMinimized;
  return /*#__PURE__*/React.createElement(Modal, {
    show: !isMinimized,
    onClose: function onClose() {
      trackEvent(MIXPANEL_EVENTS.DICOM_UPLOAD_PROGRESS_MINIMIZED);
      toggleMinimize(true);
    },
    title: t("upload_in_progress"),
    className: "sm:w-8/12 lg:w-6/12",
    closeButton: /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        trackEvent(MIXPANEL_EVENTS.DICOM_UPLOAD_PROGRESS_MINIMIZED);
        toggleMinimize(true);
      }
    }, /*#__PURE__*/React.createElement(MinimizeIcon, null))
  }, children);
};